import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'dateFormatter',
  pure: true
})
export class DateFormatterPipe implements PipeTransform {

  transform(value: any, format: string = 'DD MMM YYYY'): any {
    return moment(value).format(format);
  }

}
